import { useTranslation } from "react-i18next";

import { LanguageSwitcher } from "@/components/language-switcher";
import { ThemeToggle } from "@/components/theme-toggle";
import { TrialBadge } from "@/components/trial-badge";
import { UserMenu } from "@/components/user-menu";
import { useSession } from "@/features/auth/use-session";

/** Desktop top bar (>= lg). */
export function TopBar() {
  const { t } = useTranslation();
  const { tenant } = useSession();

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center justify-between gap-3 border-b border-border bg-surface/90 px-4 backdrop-blur lg:px-6">
      <div className="flex min-w-0 items-center gap-2">
        <span className="truncate text-sm font-medium">{tenant?.name ?? t("app.name")}</span>
        <TrialBadge />
      </div>
      <div className="flex items-center gap-1">
        <LanguageSwitcher />
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  );
}

/** Mobile top bar (< lg). */
export function MobileHeader() {
  const { t } = useTranslation();
  const { tenant } = useSession();

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center justify-between gap-2 border-b border-border bg-surface/95 px-4 backdrop-blur">
      <div className="flex min-w-0 items-center gap-2">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand text-sm font-bold text-brand-fg">
          PL
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold">{t("app.name")}</p>
          <p className="truncate text-xs text-muted">{tenant?.name ?? t("app.tagline")}</p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <TrialBadge />
        <LanguageSwitcher compact />
        <ThemeToggle compact />
        <UserMenu />
      </div>
    </header>
  );
}
